import { useEffect, useState } from 'react';

import {
  Button,
  Icon,
  Kbd,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
  Input,
  Box,
  useColorModeValue,
  Text,
  HStack,
} from '@chakra-ui/react';
import { LuHash, LuSearch, LuCornerDownLeft } from 'react-icons/lu';
import { useHotkeys } from 'react-hotkeys-hook';
// import { useDocs } from '../../services/hooks/useDocs';

interface IDoc {
  title: string;
  description: string;
}

export function SearchBox() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const colorKbd = useColorModeValue('blue.600', 'white');
  const color = useColorModeValue('gray.500', 'white');
  const bg = useColorModeValue('white', 'gray.800');
  const bgHover = useColorModeValue('gray.100', 'gray.900');

  const [search, setSearch] = useState('');

  // const { data } = useDocs();

  useHotkeys('ctrl+k', e => {
    e.preventDefault();
    onOpen();
  });

  return (
    <>
      <Button
        colorScheme="whiteAlpha"
        color="white"
        leftIcon={<Icon as={LuSearch} color="white" fontSize="18" />}
        onClick={onOpen}
      >
        <Flex pr="64">Buscar na plataforma</Flex>
        <Flex>
          <Kbd color={colorKbd}>Ctrl</Kbd> + <Kbd color={colorKbd}>K</Kbd>
        </Flex>
      </Button>

      <Modal
        onClose={onClose}
        isOpen={isOpen}
        size="2xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent rounded="2xl" bg={bg}>
          <ModalHeader>
            <Flex
              as="label"
              flex="1"
              py="2"
              px="2"
              alignSelf="center"
              color="gray.200"
              position="relative"
            >
              <Icon as={LuSearch} color={colorKbd} fontSize="26" />

              <Input
                variant="unstyled"
                color={color}
                placeholder="Buscar na plataforma"
                _placeholder={{ color: 'gray.500' }}
                size="lg"
                ml="4"
                onChange={event => setSearch(event.target.value)}
                value={search}
              />
            </Flex>
          </ModalHeader>
          {/* TODO: useDocs ainda não é usado */}
          {/* {search && data && (
            <ModalBody>
              {data &&
                data.docs.map((doc: IDoc) => (
                  <Box
                    bg={bg}
                    borderWidth="1px"
                    rounded="2xl"
                    p="4"
                    mb="2"
                    _hover={{ bg: bgHover }}
                    _groupActive={{ bg: bgHover }}
                  >
                    <Flex justify="space-between" align="center">
                      <HStack spacing={4}>
                        <Icon as={LuHash} color={color} fontSize="22" />
                        <Flex flexDir="column">
                          <Text fontSize="xs" color={color}>
                            {doc.title}
                          </Text>
                          <Text fontWeight="bold" color={color}>
                            {doc.description}
                          </Text>
                        </Flex>
                      </HStack>
                      <Icon as={LuCornerDownLeft} color={color} fontSize="20" />
                    </Flex>
                  </Box>
                ))}
            </ModalBody>
          )} */}
        </ModalContent>
      </Modal>
    </>
  );
}
